module.exports = __webpack_public_path__ + "img/img-a57a6b48.dfdf6399.png";